import { register } from 'register-service-worker';
<template>
    <v-container class="no-available text-center">
        <img class="img-fluid mb-5" :src="require(`@/assets/images/${imageName}`)" width="100px" alt="No Available" v-if="isIcon" />
        <div v-html="message"></div>
    </v-container>
</template>

<script>
export default {
    props: {
        message: String, 
        width: String, 
        isIcon: Boolean,
        imageName: {
            type: String,
            default: 'sent.svg'
        }
    },
    name: "RomaMessages"
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Cabin:wght@400;500;600;700&display=swap");
.no-available {
    text-align: center;
    width: 100%;
    h1,
    h2,
    h3 {
        font-family: "Cabin", Regular,sans-serif !important;
        text-align: center;
        letter-spacing: 0;
        color: #484848;
        opacity: 1;
        font-weight: 300;
    }
    h1 {
        font-size: 26px;
    }
    h2 {
        font-size: 22px;
    }
    h3 {
        font-size: 20px;
    }
    img {
        width: 100px;
    }
}
</style>
